/*
 * Street Garms — newsletter/header state stabiliser.
 * Presentation/state cleanup only: it does not change newsletter submission,
 * cart data, currency, consent, or Kalles navigation logic.
 */
(function () {
  'use strict';

  var settleTimer = 0;
  var lastNewsletterModalOpen = false;

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  function clearHeaderMenuState() {
    if (!isDesktop()) return;

    document.querySelectorAll('.t4s-navigation .is-action__hover').forEach(function (item) {
      item.classList.remove('is-action__hover');
    });

    document.querySelectorAll('.t4s-navigation .is--child-open').forEach(function (item) {
      item.classList.remove('is--child-open');
    });
  }

  function settleHeader() {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(function () {
      clearHeaderMenuState();

      var header = document.querySelector('.t4s-section-header');
      if (header) {
        /* Force a clean layout read after Magnific Popup restores the page. */
        header.getBoundingClientRect();
      }

      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) {}
    }, 80);
  }

  function newsletterModalIsOpen() {
    return !!document.querySelector(
      '.t4s-newsletter_pp_wrapper.mfp-ready, .t4s-newsletter_pp_wrapper .mfp-content, .mfp-wrap.t4s-newsletter_pp_wrapper'
    );
  }

  function monitorModalState() {
    var nowOpen = newsletterModalIsOpen();
    if (nowOpen === lastNewsletterModalOpen) return;

    lastNewsletterModalOpen = nowOpen;
    clearHeaderMenuState();

    /* Kalles uses a 500ms popup removal transition. Re-settle afterwards. */
    if (!nowOpen) {
      window.setTimeout(settleHeader, 560);
    }
  }

  document.addEventListener('focusin', function (event) {
    if (event.target && event.target.closest && event.target.closest('#t4s-popup__newsletter')) {
      clearHeaderMenuState();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest) return;
    if (form.closest('#t4s-popup__newsletter') || form.classList.contains('sg-newsletter__form')) {
      clearHeaderMenuState();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('#t4s-popup__newsletter button.mfp-close') : null;
    if (target) {
      clearHeaderMenuState();
      window.setTimeout(settleHeader, 560);
    }
  }, true);

  if (window.jQuery_T4NT) {
    try {
      window.jQuery_T4NT(document.body)
        .off('mail.subscribe.success.sgHeaderStability')
        .on('mail.subscribe.success.sgHeaderStability', function () {
          clearHeaderMenuState();
          /* Newsletter closes ~1.4s after success; settle after its 500ms removal. */
          window.setTimeout(settleHeader, 2050);
        });
    } catch (e) {}
  }

  var observerTarget = document.body || document.documentElement;
  if (observerTarget && window.MutationObserver) {
    new MutationObserver(monitorModalState).observe(observerTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  window.addEventListener('pageshow', function () {
    window.setTimeout(settleHeader, 120);
  });

  window.addEventListener('resize', function () {
    clearHeaderMenuState();
  });

  monitorModalState();
})();
